import { useEffect } from "react";
import LoginForm from "components/Login/LoginForm";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { extractAndStoreReferralCode } from "utils/common";
import loginImage from "assets/login-image.png";

export const Login = () => {
  const authContext = useAuth();
  const navigate = useNavigate();

  // Extract referral code from URL if present
  useEffect(() => {
    extractAndStoreReferralCode();
  }, []);

  useEffect(() => {
    if (!!authContext?.user) {
      navigate("/");
    }
  }, [authContext?.user, navigate]);

  return (
    <div className="flex flex-1 h-screen md:h-screen mobile-viewport">
      {/* Left Side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-4 md:p-16 bg-white min-h-0 overflow-y-auto mobile-form-container">
        <div className="w-full max-w-md">
          <LoginForm />
        </div>
      </div>

      {/* Right Side - Image */}
      <div className="hidden lg:flex flex-1 bg-white items-center justify-center p-6 relative overflow-hidden">
        <div className="w-full h-full flex items-center justify-center relative">
          <div className="w-full h-full rounded-2xl overflow-hidden shadow-lg">
            <img
              src={loginImage}
              alt="Open Rewards"
              className="w-full h-full object-cover"
              style={{ transform: 'scale(1.05)' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;